export const featuredTopics = [
  {
    id: 't-01',
    tag: '专题合辑',
    title: '演出市场观察：从抢票到入场的全流程',
    summary: '串起票务系统、实名核验与现场流程的公开信息，按时间线整理成可回看的索引合辑。',
    image: 'https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20poster%20illustration%20of%20a%20concert%20stage%20with%20abstract%20spotlight%20beams%2C%20warm%20cream%20background%20with%20vermillion%20red%20and%20gold%20geometric%20accents%2C%20clean%20minimal%20magazine%20feature%20art%2C%20no%20text%2C%20harmonious%20composition&width=900&height=620&seq=hl-topic-stage-01&orientation=landscape',
    count: 148,
    updated: '今日更新 12 条',
  },
  {
    id: 't-02',
    tag: '专题合辑',
    title: '短剧生态图谱：上新节奏与题材分布',
    summary: '按月份汇总竖屏上新数量与题材占比，横向对照不同平台的内容扶持方向。',
    image: 'https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20poster%20illustration%20of%20stacked%20smartphone%20screens%20and%20vertical%20timeline%20bars%2C%20warm%20cream%20background%20with%20deep%20red%20and%20amber%20chart%20shapes%2C%20clean%20minimal%20magazine%20feature%20art%2C%20no%20text%2C%20balanced%20composition&width=900&height=620&seq=hl-topic-short-02&orientation=landscape',
    count: 96,
    updated: '今日更新 8 条',
  },
  {
    id: 't-03',
    tag: '专题合辑',
    title: '行业合规小事记：指引变化与流程要点',
    summary: '把分散的指引草案、署名规范与素材授权要求集中归档，便于逐条对照查阅。',
    image: 'https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20poster%20illustration%20of%20layered%20document%20sheets%20and%20checklist%20marks%2C%20warm%20cream%20background%20with%20forest%20green%20and%20gold%20accents%2C%20clean%20minimal%20magazine%20feature%20art%2C%20no%20text%2C%20structured%20composition&width=900&height=620&seq=hl-topic-doc-03&orientation=landscape',
    count: 63,
    updated: '今日更新 5 条',
  },
];